var map = {
	"./action-green.png": 95934,
	"./add-new-doctor-green.png": 13706,
	"./archive.png": 7656,
	"./arrow-down-darkgreen.png": 97293,
	"./arrow-down-white.png": 32565,
	"./arrow-down.png": 6867,
	"./arrow-left-white.png": 82983,
	"./arrow-left.png": 19434,
	"./arrow-right-white.png": 67431,
	"./arrow-right.png": 45565,
	"./arrow-white.png": 61653,
	"./attachment-green.png": 84217,
	"./attachment.png": 41876,
	"./calendar.png": 13607,
	"./check.png": 90192,
	"./checked-green.png": 71131,
	"./clock-white.png": 62291,
	"./cps_logo.png": 97585,
	"./doctor-green.png": 29131,
	"./doctor-grey.png": 54853,
	"./doctor-like-button.png": 60800,
	"./doctor-red.png": 32317,
	"./doctor.png": 28836,
	"./download-blue.png": 75885,
	"./download-green.png": 45705,
	"./edit.png": 9750,
	"./envelope-send.png": 13814,
	"./envelope-white.png": 21575,
	"./error.png": 22949,
	"./evelope.png": 69625,
	"./eye.png": 51543,
	"./filter-white.png": 56331,
	"./info-blue.png": 84490,
	"./info-grey.png": 38461,
	"./lock.png": 75084,
	"./logo.png": 71482,
	"./logout.png": 31853,
	"./menu.png": 33073,
	"./multi-choice.png": 59960,
	"./notice-board.png": 89861,
	"./patients2-green.png": 65828,
	"./patients2-grey.png": 19302,
	"./patients2-red.png": 58001,
	"./patients2.png": 2162,
	"./pdf.png": 89859,
	"./pdf2.png": 84161,
	"./person-arrow-white.png": 29334,
	"./plus-green-bg.png": 96638,
	"./plus-white.png": 56285,
	"./refresh.png": 34050,
	"./search-icon.png": 63616,
	"./send-envelop-green.png": 38138,
	"./send-envelop-red.png": 991,
	"./send-envelop.png": 49106,
	"./settings.png": 19486,
	"./settings2.png": 85362,
	"./smartphone.png": 14618,
	"./sort-icon.png": 38400,
	"./success.png": 39307,
	"./trash.png": 87026,
	"./unchecked-red.png": 55775,
	"./warning.png": 30599,
	"./x-dark-green.png": 63139,
	"./x-green.png": 16359,
	"./x.png": 7658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30397;